import styled from "styled-components"
import bgHeroOlimpo from "../../../assets/images/bgHeroOlimpo.png"
export const Hero = styled.div`
  padding: 3rem 0;
  background-image: url(${bgHeroOlimpo});
  background-repeat: no-repeat;
  background-size: 65%;
  background-color: ${({ theme }) => theme.colors.amarillo};
  color: ${({ theme }) => theme.colors.azul};
  .container {
    display: grid;
  }
  h1,
  h2,
  h3 {
    text-transform: uppercase;
  }
  h1,
  h2,
  h3,
  h4,
  p {
    margin: 0;
    font-family: "Aller";
    margin-bottom: 0.3rem;
  }
  img {
    text-align: center;
    width: 80%;
    justify-self: center;
  }
  .info {
    justify-self: end;
    max-width: 35%;
    .titleCaracteristicas {
      margin-top: 1rem;
    }
  }
  .caracteristicas {
    display: grid;
    grid-template-columns: auto auto;
    text-align: center;
    .col1 {
      border-top: 2px solid ${({ theme }) => theme.colors.azul};
      border-right: 2px solid ${({ theme }) => theme.colors.azul};
      /*para el espacio de arriba de la tabla
            */
      h4 {
        &:first-child {
          margin-top: 0.7rem;
        }
      }
    }
    .col2 {
      border-top: 2px solid ${({ theme }) => theme.colors.azul};
      /*para el espacio de arriba de la tabla
            */
      p {
        &:first-child {
          margin-top: 0.7rem;
        }
      }
    }
  }
  @media (max-width: 800px) {
    background-image: none;
    .container {
      grid-template-columns: 1fr 1fr;
      grid-gap: 1.2rem;
      .info {
        max-width: 100%;
      }
      img {
        width: 100%;
        align-self: center;
      }
    }
  }
  @media (max-width: 500px) {
    .container{
      grid-template-columns:1fr;
    }
  }
`
